import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail
} from './dossier-invoice.action';



import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { DossierInvoicesTableService } from './dossier-invoice-table.service';
import { fetchSingleRecordSuccess as dossierRecordSuccess } from '../Dossier/dossier.action';
import { RootReducerState } from '..';
import { Store } from '@ngrx/store';
import { RouterService } from 'src/app/core/services/router.service';


@Injectable()
export class DossierInvoicesRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap((data) => {
                const url = 'dossier-invoice/'+data.id+'/invoice';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const listData = data.records;
                        const total = data.pagination.total;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: listData, total: total});

                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                
                const dossierId = data.dossierId;
                const url = `dossier-invoice/${data.dossierId}/invoice/${data.id}/edit`;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        const data = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(dossierRecordSuccess({singleData: data.dossier, dossierData: {countryList: [], clubs: []} }));
                        
                        return fetchSingleRecordSuccess({singleData: data.record});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, `/dossiers/detail/${dossierId}`, { activeTab: 'invoices' });
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private moduleTableService: DossierInvoicesTableService,
        private tableService: DatatableService,
        private store: Store<RootReducerState>,
        private routeService: RouterService
    ) { }

}